<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <span class="a-fs-16 a-fw-700">账单</span>
            <div class="a-flex-rcc">
                <!-- <el-button type="primary" >更新三方</el-button> -->
                <el-button icon="el-icon-upload2" class="s-btn-exp" @click="exportfile">导出</el-button>
            </div>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="true" id="leSearch">
                <le-input label="订单号" v-model="pageParam.params.orderSn" />
                <le-date-range label="交易时间" :minDate.sync="pageParam.params.startTime" :maxDate.sync="pageParam.params.endTime" valueFormat="yyyy-MM-dd HH:mm:ss" :defaultTime="['00:00:00','23:59:59']" />
                <le-input label="用户账号" v-model="pageParam.params.phone" />
                <le-select-remote-search label="收款商户" v-model="pageParam.params.merchantNo" :options="optionsMerchant" placeholder="请选择" />
                <le-select-local-search label="订单类型" v-model="pageParam.params.productType" :options="productTypeDic" />
                <le-select-local-search label="收支类型" v-model="pageParam.params.recordType" :options="recordTypeDic" />
                <le-select-local-search label="支付渠道" v-model="pageParam.params.payChannel" :options="payChannelDic" />
                <le-select-local-search label="校验结果" v-model="pageParam.params.checkResult" :options="checkResultDic" />
                <le-input label="三方交易号" v-model="pageParam.params.transactionId" />
            </le-search-form>
            <le-pagview ref="financeFPZS" @setData="setTableData" :pageParam="pageParam" :pagerCount="5" :isFixed="true" :tableRef="$refs.financeFPZSList">
                <el-table ref="financeFPZSList" :data="tableData" :highlight-current-row="true" v-sticky="{ top: 0, parent:'.el-card__body' }" style="width: 100%">
                    <el-table-column prop="" label="订单号" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.orderSn || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="交易时间" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.payTime || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="myOrderNum" label="用户账号" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.phone || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="myOrderNum" label="收款商户" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.merchantName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="payeeCompanyName" label="订单类型" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.productType | initDic(productTypeDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="payeeCompanyName" label="收支类型" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.recordType | initDic(recordTypeDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="payeeCompanyName" label="支付渠道" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.payChannel | initDic(payChannelDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="payeeCompanyName" label="三方交易号" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.tradeNo || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="payeeCompanyName" label="流水金额" min-width="120">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.turnoverAmount) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="payeeCompanyName" label="三方交易金额" min-width="120">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.platformAmount) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="payeeCompanyName" label="校验结果" min-width="120">
                        <template slot-scope="{ row }">
                            <span :class="row.checkResult == 1?'a-c-green':'a-c-error'">{{ row.checkResult | initDic(checkResultDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="payeeCompanyName" label="备注" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.remark || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="操作" width="75" fixed="right">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="添加备注" placement="top">
                                <img src="../../assets/icon/option-edit.png" class="a-wh-16" @click="handleEdit(scope.row)" />
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="height: 16px"></div>
                <template slot="footerContent" slot-scope="scope" >
                    <div class="a-flex-rfsc a-flex-wrap">
                        <div class="a-flex-rfsc" style="margin-right: 20px">
                            <span class="a-fs-12 a-c-normal">流水金额:</span>
                            <span class="a-fs-16 a-c-master a-fw-b">￥{{util.numFormat(scope.val.turnoverAmountTotal)}}</span>
                        </div>
                        <div class="a-flex-rfsc" style="margin-right: 20px">
                            <span class="a-fs-12 a-c-normal">三方交易金额：</span>
                            <span class="a-fs-16 a-c-master a-fw-b">￥{{util.numFormat(scope.val.platformAmountTotal)}}</span>
                        </div>
                        <div class="a-flex-rfsc">
                            <span class="a-fs-12 a-c-normal">差异值：</span>
                            <span class="a-fs-16 a-c-master a-fw-b">￥{{util.numFormat(scope.val.turnoverAmountTotal - scope.val.platformAmountTotal)}}</span>
                        </div>
                    </div>
                </template>
            </le-pagview>
        </el-card>
    </div>
</template>

<script>
    import util from '../../../src/utils/util'
    export default {
        data () {
            return {
                tableData: [],
                util: util,
                pageParam: {
                    url: this.$Config.apiUrl.billPage,
                    method: "post",
                    params: {
                        checkResult: '',
                        endTime: this.$getDay.getTodayBeforeDays(0) + ' 23:59:59',
                        startTime: this.$getDay.getTodayBeforeDays(1) + ' 00:00:00',
                        merchantName: '',
                        merchantNo: '',
                        orderSn: '',
                        payChannel: '',
                        phone: '',
                        productType: '',
                        recordType: '',
                        transactionId: '',
                    },
                    freshCtrl: 1,
                },
                optionsMerchant: {
                    url: this.$Config.apiUrl.merchantList,
                    method: "post",
                    params: {
                        tripartiteType: 3
                    },
                    showLoading: false,
                    labelKey: "merchantName",
                    valueKey: "merchantNo",
                    searchKey: "merchantName",
                },
                productTypeDic: [],//商品类型
                recordTypeDic: [],//收支类型
                payChannelDic: [],
                checkResultDic: [{
                    label: '正常',
                    value: '1'
                },{
                    label: '异常',
                    value: '2'
                }],//
            }
        },
        created () {
            this.$getDic('productType', 'select').then(res=>{ this.productTypeDic = res; })
            this.$getDic('pecodeType', 'select').then(res=>{ this.recordTypeDic = res; })
            this.$getDic('baofuPayChannel', 'select').then(res=>{ this.payChannelDic = res; })
        },
        activated () {
            this.pageParam.freshCtrl++;
        },
        methods: {
            setTableData(data) {
                this.tableData = data;
            },
            handlerRest() {
                this.pageParam.params = {
                    checkResult: '',
                    endTime: '',
                    startTime: '',
                    merchantName: '',
                    orderSn: '',
                    payChannel: '',
                    phone: '',
                    productType: '',
                    recordType: '',
                    transactionId: '',
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs['financeFPZS'].pageNum = 1
                this.pageParam.freshCtrl++;
            },
            handleEdit (datas) {
                this.$prompt('', '请输入备注', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'textarea',
                    inputValidator: (val)=>{
                        if(val.length > 200) {
                            return '最多可输入200字'
                        }
                    }
                }).then(({ value }) => {
                    this.$Axios._post({
                        url: this.$Config.apiUrl.billRemark,
                        params: {
                            "id": datas.id,
                            "remark": value
                        },
                    })
                    .then(res => {
                        this.$message.success('操作成功')
                        this.pageParam.freshCtrl++;
                    })
                    .catch((error) => {});
                }).catch(() => {});
            },
            exportfile () {
                if(util.isAllEmpty(this.pageParam.params)) {
                    this.$message.error('请至少选择一项筛选条件')
                    return
                }
                if(this.$getDay.enumerateDaysBetweenDates(this.pageParam.params.startTime,this.pageParam.params.endTime).length > 92){
                    this.$message.error('最大导出范围3个月')
                    return
                }
                this.$exfile({
                    code: 33,
                    fileName: this.$getDay.getTimeStampToStr(new Date().getTime()) + '_三方流水核对表',
                    startTime: this.pageParam.params.startTime ? this.pageParam.params.startTime.split(' ')[0] : '',
                    endTime: this.pageParam.params.endTime ? this.pageParam.params.endTime.split(' ')[0] : '',
                    params: {
                        ...this.pageParam.params,
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
		/*width: 0;宽度为0隐藏*/
		width: 0 !important;
		height: 0 !important;
	}
	/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
		height: 100% !important;
	}
    /deep/ .companySelect{
        .a-ml-20{
            margin-left: 10px !important;
        }
    }
</style>